import { render } from "./theme26.vue?vue&type=template&id=d4997246&scoped=true"
import script from "./theme26.vue?vue&type=script&lang=js"
export * from "./theme26.vue?vue&type=script&lang=js"

import "./theme26.vue?vue&type=style&index=0&id=d4997246&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-d4997246"

export default script